import React from 'react';
import { getIconComponent } from '../../utils/iconHelper';

const SECTION_COLORS = {
  "National Articles": "#10b981",
  "Premium & Imported": "#3b82f6",
  "Accessories": "#8b5cf6",
  "Fragrance & Grooming": "#f97316"
};

const ShopSectionPills = ({
  activeSections = [],
  onSectionToggle,
  sections = [],
  sort,
  onSortChange,
  onClearSections
}) => {
  return (
    <div className="shop-section-pills-container">
      <button
        onClick={() => {
          if (activeSections.length > 0 && onClearSections) {
            onClearSections();
          }
        }}
        className={`shop-section-pill ${activeSections.length === 0 ? 'active' : ''}`}
        style={{
          "--pill-color": "#f97316",
          "--pill-color-glow": "rgba(249, 115, 22, 0.15)"
        }}
      >
        <span>All Products</span>
      </button>

      {sections.map((section) => {
        const title = section.title;
        const color = SECTION_COLORS[title] || section.color || "#f97316";
        const colorGlow = color.startsWith("#") ? `${color}26` : "rgba(255, 255, 255, 0.15)";
        const IconComponent = getIconComponent(section.icon);
        const isActive = activeSections.includes(title);

        return (
          <button
            key={title}
            onClick={() => onSectionToggle(title)}
            className={`shop-section-pill ${isActive ? 'active' : ''}`}
            style={{
              "--pill-color": color,
              "--pill-color-glow": colorGlow
            }}
          >
            {IconComponent && <IconComponent size={16} className="pill-icon" />}
            <span>{title}</span>
          </button>
        );
      })}

      {onSortChange && (
        <div className="shop-desktop-sort-container">
          <select
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
            className="toolbar-sort-select"
          >
            <option value="latest">Latest</option>
            <option value="oldest">Oldest</option>
            <option value="price-low">Price Low → High</option>
            <option value="price-high">Price High → Low</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default ShopSectionPills;